<div class="warehouse-deadlines">
  <div class="row mat-elevation-z4">
    @for (outlet of projectCredits; track outlet) {
      @if (outlet.warehoused) {
        <div class="section">
          <div class="fund-header">
            {{outlet.fund?.name ?? outlet.certificatedOutlet?.organization?.name}}
          </div>
          @if (!editMode) {
            <table mat-table [dataSource]="[outlet]">
              <ng-container matColumnDef="warehouse_funding_deadline_date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.warehouse_funding_deadline_date !== null) {
                    {{row.warehouse_funding_deadline_date | date: 'MM/dd/yyyy'}}
                  }
                  @if (row.warehouse_funding_deadline_date === null) {
                    --
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="warehouse_funding_deadline_time">
                <th mat-header-cell *matHeaderCellDef>Time</th>
                <td mat-cell *matCellDef="let row">{{renderDateTime(row)}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['warehouse_funding_deadline_date', 'warehouse_funding_deadline_time']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['warehouse_funding_deadline_date', 'warehouse_funding_deadline_time'];"></tr>
            </table>
          }
          @if (editMode) {
            <table mat-table [dataSource]="[outlet]">
              <form [formGroup]="getOutletForm(outlet)">
                <ng-container matColumnDef="warehouse_funding_deadline_date">
                  <th mat-header-cell *matHeaderCellDef>Date</th>
                  <td mat-cell *matCellDef="let row">
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" formControlName="warehouse_funding_deadline_date" name="warehouse_funding_deadline_date">
                      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="warehouse_funding_deadline_time">
                  <th mat-header-cell *matHeaderCellDef>Time</th>
                  <td mat-cell *matCellDef="let row">
                    <input
                      ngDefaultControl
                      type="time"
                      class="time-picker"
                      formControlName="warehouse_funding_deadline_time"
                      />
                  </td>
                </ng-container>
                <ng-container matColumnDef="warehouse_funding_deadline_timezone">
                  <th mat-header-cell *matHeaderCellDef>Timezone</th>
                  <td mat-cell *matCellDef="let row">
                    <mat-form-field>
                      <mat-select formControlName="warehouse_funding_deadline_timezone">
                        @for (tz of timezoneList; track tz) {
                          <mat-option [value]="tz">{{tz.abbr}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['warehouse_funding_deadline_date', 'warehouse_funding_deadline_time', 'warehouse_funding_deadline_timezone']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['warehouse_funding_deadline_date', 'warehouse_funding_deadline_time', 'warehouse_funding_deadline_timezone']"></tr>
              </form>
            </table>
          }
        </div>
      }
    }
  </div>
</div>
